import { useTranslation } from 'react-i18next';
import {
  Image,
  ItemsWrapper,
  ItemWrapper,
  Title,
  SectionRoot,
  Subtitle,
  TextWrapper,
  ButtonWrapper,
} from './styles';
import Button from '@components/Button';
import icebreakerImage from '@assets/images/ei-7.jpg';
import worldCafeImage from '@assets/images/IoTW_Berlin_11.png';
import keynoteImage from '@assets/images/speaker_image_1.jpg';
import networkingDinnerImage from '@assets/images/IoTW_Berlin_4.jpg';
import { useTheme } from 'styled-components';
import { useMobileWidth } from '@utils/hooks';
import { ROUTES } from '@constants/routes';

export interface MultitouchpointItemProps {
  title: string;
  subtitle: string;
  image: string;
}
export const MultitouchpointItem = ({
  title,
  subtitle,
  image,
}: MultitouchpointItemProps) => {
  return (
    <ItemWrapper>
      <Image src={image} alt={`Multitouchpoint: ${title} image`} />

      <TextWrapper>
        <mark>
          <Title>{title}</Title>
        </mark>
        <Subtitle>{subtitle}</Subtitle>
      </TextWrapper>
    </ItemWrapper>
  );
};

const Multitouchpoint = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMobileWidth();

  return (
    <section>
      <SectionRoot>
        <ItemsWrapper>
          <MultitouchpointItem
            title={t('icebreaker-session')}
            subtitle={t('icebreaker-session-subtitle')}
            image={icebreakerImage}
          />
          <MultitouchpointItem
            title={t('keynote-session')}
            subtitle={t('keynote-session-subtitle')}
            image={keynoteImage}
          />
          <MultitouchpointItem
            title={t('world-cafe-session')}
            subtitle={t('world-cafe-session-subtitle')}
            image={worldCafeImage}
          />
          <MultitouchpointItem
            title={t('networking-dinner-session')}
            subtitle={t('networking-dinner-session-subtitle')}
            image={networkingDinnerImage}
          />
        </ItemsWrapper>

        {!isMobile && (
          <ButtonWrapper>
            <Button
              title={t('multitouchpoint-button-text')}
              backgroundColor={theme.color.mobilityBlue}
              hoverBackgroundColor={theme.color.mobilityGrey}
              textColor={theme.color.white}
              borderRadius={theme.borderRadius.radius10}
              fontSize={theme.fontSize.size20}
              padding="0.8rem 3.5rem"
              width="max-content"
              onClick={() => {
                window.location.href = t(
                  ROUTES.MULTI_TOUCHPOINT_NETWORKING_URL
                );
              }}
            />
          </ButtonWrapper>
        )}
      </SectionRoot>
    </section>
  );
};

export default Multitouchpoint;
